import React from 'react';
import PropTypes from 'prop-types';
import './LoadingSpinner.css';

/**
 * Loading spinner component
 * @param {Object} props - Component props
 * @param {string} props.size - Spinner size (small, medium, large)
 * @param {string} props.message - Optional loading message
 * @param {boolean} props.overlay - Whether to show as overlay
 * @param {boolean} props.centered - Whether to center on page
 */
function LoadingSpinner({ size, message, overlay, centered }) {
  const spinnerClass = `spinner spinner-${size} ${centered ? 'centered' : ''}`;
  
  const content = (
    <>
      <div className={spinnerClass}>
        <div className="spinner-border">
          <div className="spinner-circle"></div>
        </div>
      </div>
      {message && <div className="spinner-message">{message}</div>}
    </>
  );
  
  if (overlay) {
    return (
      <div className="spinner-overlay">
        <div className="spinner-content">
          {content}
        </div>
      </div>
    );
  }
  
  return <div className="spinner-container">{content}</div>;
}

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  message: PropTypes.string,
  overlay: PropTypes.bool,
  centered: PropTypes.bool
};

LoadingSpinner.defaultProps = {
  size: 'medium',
  overlay: false,
  centered: false
};

export default LoadingSpinner;
